// Lightweight imperative pub-sub so any file can trigger a toast or a
// confirm dialog without wiring local state — <NotificationCenter/> (mounted
// once near the app root) is the single subscriber that renders them.

let toastListener = null;
let confirmListener = null;
let idCounter = 0;

export function _registerToastListener(fn) {
  toastListener = fn;
}

export function _registerConfirmListener(fn) {
  confirmListener = fn;
}

function pushToast(message, type) {
  if (!toastListener) return;
  toastListener({ id: ++idCounter, message, type });
}

export const notify = {
  success: (message) => pushToast(message, "success"),
  error: (message) => pushToast(message, "error"),
  warning: (message) => pushToast(message, "warning"),
  info: (message) => pushToast(message, "info"),
};

/**
 * Promise-based replacement for window.confirm().
 * Usage: if (await confirmDialog("Delete this record?")) { ... }
 * Also accepts an options object: confirmDialog({ title, message, confirmText, cancelText, danger })
 */
export function confirmDialog(options) {
  const opts = typeof options === "string" ? { message: options } : options;
  return new Promise((resolve) => {
    if (!confirmListener) {
      resolve(window.confirm(opts.message));
      return;
    }
    confirmListener({ ...opts, resolve });
  });
}
